import { Component, OnChanges, Input } from "@angular/core";

import * as Highcharts from "highcharts";

@Component({
	selector: "app-dvs-chart",
	templateUrl: "./dvs-chart.component.html",
	styleUrls: ["./dvs-chart.component.scss"]
})
export class DvsChartComponent implements OnChanges {
	@Input()
	options: Highcharts.Options;
	@Input()
	height: string;
	@Input()
	light: boolean;
	@Input()
	error: string;
	@Input()
	timezone: number;
	@Input()
	short: boolean;

	private chartInstance: Highcharts.Chart;
	private lastSelected: Highcharts.Point;

	public Highcharts = Highcharts;

	ngOnChanges() {
		if (!this.height) {
			this.height = "300px";
		}
		if (!this.timezone) {
			this.timezone = 0;
		}
		Highcharts.setOptions({
			time: {
				timezoneOffset: -this.timezone * 60,
			},
		});

	}
	onLoad(chartInstance) {
		this.chartInstance = chartInstance;
	}

	public UpdatePlotLine() {
		if (this.chartInstance && this.chartInstance.xAxis && this.chartInstance.xAxis.length) {
			(this.chartInstance.xAxis[0] as any).plotLinesAndBands[0].render();
		}
	}

	/** Select a point from a given series, where point[key] matches value */
	public SelectPoint(seriesIndex?: number, pointKey?: string, pointValue?: number) {
		if (this.lastSelected && this.lastSelected.setState) {
			this.lastSelected.setState();
			this.chartInstance.tooltip.hide();
			this.lastSelected = undefined;
		}
		if (seriesIndex !== undefined && pointKey !== undefined) {
			const series = this.chartInstance.series[seriesIndex];
			const point = series.data.find(item => item[pointKey] === pointValue);
			point.setState("hover");
			this.chartInstance.tooltip.refresh(point);
			this.lastSelected = point;
		}
	}

	public SetSeriesData(seriesIndex: number, data: any[]) {
		this.SelectPoint();
		this.chartInstance.series[seriesIndex].setData(data);
	}

	public SetXZoom(min: number, max: number, animate = true) {
		const chartAny = this.chartInstance as any;
		if (chartAny.showResetZoom) {
			chartAny.xAxis[0].setExtremes(min, max, true, animate);
			if (min || max) {
				// This is undocumented / no typescript defs so keep an eye on it
				chartAny.showResetZoom();
			}
		}
	}
}
